import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-22451790"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hardware-info-wrap cm-form-info-grid" }
const _hoisted_2 = { class: "cm-form-item" }
const _hoisted_3 = { class: "cm-form-item" }
const _hoisted_4 = { class: "cm-form-item" }
const _hoisted_5 = { class: "cm-form-item" }
const _hoisted_6 = { class: "cm-form-item" }
const _hoisted_7 = { class: "cm-form-item" }
const _hoisted_8 = { class: "cm-form-item" }
const _hoisted_9 = { class: "cm-form-item" }
const _hoisted_10 = { class: "cm-form-item" }
const _hoisted_11 = { class: "cm-form-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_speed_format = _resolveDirective("speed-format")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwComputerModel')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.computer_model || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwCpu')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.cpu || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwMainboard')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.main_bord || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwSerialNumber')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.sn_code || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwMemory')), 1),
      _withDirectives(_createElementVNode("span", null, null, 512), [
        [_directive_speed_format, _ctx.compData.memory_capacity * 1024 * 1024]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwDisk')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.hard_disk || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwGpu')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.graphics_card || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwNic')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.network_card || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwDisplay')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.display || '--'), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t('groupClient.terminalInfoDetail.hwAudio')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.compData.audio_card || '--'), 1)
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}